import PropTypes from "prop-types"
import { useRef } from "react"
import ReactPlayer from "react-player/lazy"

import { useIntersection } from "helpers/use-intersection"

/**
 * Product video component
 * @param {number} index - video index
 * @param {number} currentSlideIndex - current slide index
 * @param {string} video - video url
 */
const ProductVideo = ({ index, currentSlideIndex, video }) => {
  const ref = useRef()
  const inViewport = useIntersection(ref, "0px")

  return (
    <div
      className="max-w-500 relative mx-auto h-auto w-full text-center"
      ref={ref}
    >
      {inViewport && (
        <ReactPlayer
          config={{
            file: {
              attributes: {
                preload: "metadata",
              },
            },
            vimeo: {
              url: { video },
            },
          }}
          controls={currentSlideIndex === index}
          height="100%"
          loop
          muted
          playing={currentSlideIndex === index}
          playsinline
          url={video}
          width="100%"
        />
      )}
    </div>
  )
}

ProductVideo.propTypes = {
  currentSlideIndex: PropTypes.number,
  index: PropTypes.number,
  video: PropTypes.string,
}

export default ProductVideo
